module.exports = __webpack_public_path__ + "static/media/twitter.8614d726.webp";